import appStorage from 'storage/appStorage'
import { fetchJson } from './fetch'

type CountryByLocationResponse = {
  iso2?: string
}

export const lookupCountryIso2ByLocation = async (lat: number, lon: number): Promise<string | null> => {
  const orgId = appStorage.getOrgId()
  if (!orgId) {
    return null
  }

  const token = appStorage.getToken()
  const url = `${window.API_BASE_URL}orgs/${orgId}/countries/by_location/${lon},${lat}`

  try {
    const response = await fetchJson(url, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
    const iso2 = (response.json as CountryByLocationResponse | null)?.iso2
    return typeof iso2 === 'string' && iso2.length === 2 ? iso2.toUpperCase() : null
  } catch {
    return null
  }
}
